import { AppNode } from "@features/builder/graph/types"

export const sortNodesAlphabetically = (a: AppNode, b: AppNode) =>
  String(a.data.label ?? "").localeCompare(String(b.data.label ?? ""))
